import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../STATE__generation';

export const REMOTE__user_task_load_generations_by_generation_id = createAsyncThunkSafe<void, string>(
  ENUM__network_event_client_to_server.USER_TASK_LOAD_GENERATIONS_BY_GENERATION_ID,
  async (generation_id, thunkApi): Promise<void> => {
    await send_to_server<void>(ENUM__network_event_client_to_server.USER_TASK_LOAD_GENERATIONS_BY_GENERATION_ID, generation_id);
  },
);

export function INIT_REMOTE__user_task_load_generations_by_generation_id(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__user_task_load_generations_by_generation_id.pending, state => {})
    .addCase(REMOTE__user_task_load_generations_by_generation_id.rejected, (state, action) => {})
    .addCase(REMOTE__user_task_load_generations_by_generation_id.fulfilled, (state, action: PayloadAction<void>) => {});
}
